<template>
  <div>
    <div @click="launchFilePicker()" @dragover.prevent @drop="onDrop">
      <slot name="activator" />
    </div>
    <input
      ref="uploadFile"
      type="file"
      style="display:none"
      :accept="filetype"
      @change="onFileChange($event.target.files)"
    >
    <v-dialog v-model="errorDialog" max-width="300">
      <v-card>
        <v-card-text>{{ errorMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="errorDialog = false">
            Got it!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-modal
      :show="showErrorModal"
      :text="errorMessage"
      :width="'30%'"
      @close-modal="showErrorModal=false"
      @click-button="showErrorModal=false"
    />
  </div>
</template>

<script>
import ConfirmModal from '../modals/ConfirmModal'
export default {
  components: {
    ConfirmModal
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    filetype: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    showErrorModal: false,
    errorMessage: 'This file is too large, try uploading an image no larger than 1 MB',
    errorDialog: null
  }),

  methods: {
    launchFilePicker() {
      this.$refs.uploadFile.click()
    },
    onDrop(e) {
      e.preventDefault()
      e.stopPropagation()
      const files = e.dataTransfer.files
      this.onFileChange(files)
    },

    onFileChange(file) {
      let newFile = file[0]
      // if (newFile.type.includes('image')) {
      //   if (newFile.size <= 1000000) {
      //     return this.createFileUrl(newFile)
      //   }
      //   this.showErrorModal = true
      //   return this.showErrorModal
      // }
      return this.createFileUrl(newFile)
    },
    createFileUrl(newFile) {
      let fileURL = URL.createObjectURL(newFile)
      this.$emit('input', { newFile, fileURL })
    }
  }
}
</script>
<style lang="sass">
.modal-send-message__title
  font-size: $hwayzFont1rem8
  text-transform: none !important
  margin-top: 4rem !important
</style>
